<template>
  <div class="conversation-list">
    <div
      v-for="(item, index) in conversationList"
      :key="index"
      class="conversation-item"
      :class="{ active: item.isActive }"
      @click="handleConversationClick(item)"
    >
      <div class="avatar-container">
        <img :src="item.avatar || defaultAvatar" class="avatar" />
        <!-- <div v-if="item.unread_msg_num > 0" class="unread-badge">
          {{ item.unread_msg_num > 99 ? "99+" : item.unread_msg_num }}
        </div> -->
      </div>
      <div class="conversation-info">
        <div class="conversation-header">
          <div class="name">
            {{ item.name || "未知" }}
          </div>
          <div class="time">{{ formatTime(item.last_msg_time) }}</div>
        </div>
        <div class="conversation-content">
          <div
            class="message-preview"
            :class="{ unread: item.unread_msg_num > 0 }"
          >
            {{ item.last_msg }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ConversationList",
  data() {
    return {
      defaultAvatar: "https://cdn.moguocdn.com/cdn/static/images/im_avatar.png",
    };
  },
  computed: {
    ...mapState("newChat", ["privateSessionList"]),
    conversationList() {
      return this.privateSessionList || [];
    },
  },
  methods: {
    handleConversationClick(item) {
      this.$emit("select-conversation", item);
    },
    formatTime(timestamp) {
      if (!timestamp) return "";

      const now = new Date();
      const date = new Date(timestamp * 1000);

      // 同一天显示时间
      if (now.toDateString() === date.toDateString()) {
        return (
          date.getHours().toString().padStart(2, "0") +
          ":" +
          date.getMinutes().toString().padStart(2, "0")
        );
      }

      // 一周内显示星期几
      const dayDiff = Math.floor((now - date) / (24 * 60 * 60 * 1000));
      if (dayDiff < 7) {
        const weekdays = [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六",
        ];
        return weekdays[date.getDay()];
      }

      // 其他显示日期
      return date.getMonth() + 1 + "/" + date.getDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.conversation-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  /* 滚动条样式 */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #27272a;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .conversation-item {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #27272a;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #27272a;
    }

    &.active {
      background-color: #2b2b2d;
    }

    .avatar-container {
      position: relative;
      margin-right: 6px;

      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
      }

      .unread-badge {
        position: absolute;
        top: -4px;
        right: -4px;
        min-width: 16px;
        height: 16px;
        background-color: #f53f3f;
        border-radius: 8px;
        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
      }
    }

    .conversation-info {
      flex: 1;
      overflow: hidden;

      .conversation-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;

        .name {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .time {
          font-weight: 500;
          font-size: 12px;
          color: #86909c;
          white-space: nowrap;
          margin-left: 8px;
        }
      }

      .conversation-content {
        display: flex;
        align-items: center;

        .message-preview {
          flex: 1;
          font-weight: 500;
          font-size: 11px;
          color: #86909c;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
